var render = function render(){
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.radioContainer] = _vm.theme === 'default', _class[_vm.$style.radioSimpleContainer] = _vm.theme === 'simple', _class[_vm.$style.selected] = _vm.modelValue === _vm.value, _class),
    on: {
      "click": _vm.clickRadio
    }
  }, [_c('input', _vm._b({
    attrs: {
      "type": "radio",
      "name": _vm.name
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.modelValue === _vm.value
    },
    on: {
      "change": _vm.clickRadio
    }
  }, 'input', _vm.$attrs, false)), _c('p', [_vm._v(_vm._s(_vm.label))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }